import {React} from 'react';
import './style.scss';

const Divider = ({noMargin = false}) => {
  return (
    <div className={`divider ${noMargin ? 'no-margin' : ''}`}/>
  )
}

export default Divider;